import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-login-redirect-component',
  templateUrl: './login-redirect.component.html',
  styleUrls: ['./login-redirect.component.scss']
})
export class LoginRedirectComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }
}
